import {
  FaHtml5,
  FaCss3Alt,
  FaReact,
  FaSass,
  FaJava,
  FaNodeJs,
  FaAws,
} from "react-icons/fa";
import {
  SiJavascript,
  SiFlutter,
  SiBootstrap,
  SiMysql,
  SiPostgresql,
  SiAzuredevops,
  SiPostman,
  SiGithub,
  SiDart,
} from "react-icons/si";
import { TbApi, TbBrandNextjs } from "react-icons/tb";

export const skillList = [
  {
    id: 1,
    name: "JavaScript",
    icon: <SiJavascript size={50} />,
  },
  {
    id: 2,
    name: "Java",
    icon: <FaJava size={50} />,
  },
  {
    id: 3,
    name: "Dart",
    icon: <SiDart size={50} />,
  },
  // Web Technologies
  {
    id: 4,
    name: "HTML5",
    icon: <FaHtml5 size={50} />,
  },
  {
    id: 5,
    name: "CSS3",
    icon: <FaCss3Alt size={50} />,
  },
  {
    id: 6,
    name: "Bootstrap",
    icon: <SiBootstrap size={50} />,
  },
  {
    id: 7,
    name: "Sass",
    icon: <FaSass size={50} />,
  },
  {
    id: 8,
    name: "React",
    icon: <FaReact size={50} />,
  },
  {
    id:9,
    name: "Next.js",
    icon: <TbBrandNextjs size={50} />,
  },
  {
    id: 10,
    name: "Flutter",
    icon: <SiFlutter size={50} />,
  },
  {
    id: 11,
    name: "Node.js",
    icon: <FaNodeJs size={50} />,
  },
  // Databases
  {
    id: 12,
    name: "MySql",
    icon: <SiMysql size={50} />,
  },
  {
    id: 13,
    name: "PostgreSQL",
    icon: <SiPostgresql size={50} />,
  },
  {
    id: 14,
    name: "AWS",
    icon: <FaAws size={50} />,
  },
  {
    id: 15,
    name: "Azure DevOps",
    icon: <SiAzuredevops size={50} />,
  },
  {
    id: 16,
    name: "Postman",
    icon: <SiPostman size={50} />,
  },
  {
    id: 17,
    name: "Github",
    icon: <SiGithub size={50} />,
  },
  {
    id: 18,
    name: "Restful API",
    icon: <TbApi size={50} />,
  },
];
